<script setup>
import { useRoute } from "vue-router";

import SidenavItem from "./SidenavItem.vue";
import SidenavCard from "./SidenavCard.vue";



const getRoute = () => {
  const route = useRoute();
  const routeArr = route.path.split("/");
  return routeArr[1];
};


</script>
<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item
          to="/dashboard-default"
          :class="getRoute() === 'dashboard-default' ? 'active' : ''"
          :navText="$t('routesMenu.homePage')"
        >
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
            to="/data"
            :class="getRoute() === 'data' ? 'active' : ''"
            :navText="$t('routesMenu.data')"
        >
          <template v-slot:icon>
            <i
                class="ni ni-chart-bar-32 text-warning text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/device"
          :class="getRoute() === 'device' ? 'active' : ''"
          :navText="$t('routesMenu.device')"
        >
          <template v-slot:icon>
            <i
              class="ni ni-support-16 text-secondary text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/alarm"
          :class="getRoute() === 'alarm' ? 'active' : ''"
          :navText="$t('routesMenu.alarm')"
        >
          <template v-slot:icon>
            <i class="ni ni-time-alarm text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/inform"
          :class="getRoute() === 'inform' ? 'active' : ''"
          :navText="$t('routesMenu.inform')"
        >
          <template v-slot:icon>
            <i class="ni ni-app text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
            to="/notification"
            :class="getRoute() === 'notification' ? 'active' : ''"
            :navText="$t('routesMenu.notification')"
        >
          <template v-slot:icon>
            <i class="ni ni-email-83 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

<!--      <li class="nav-item">-->
<!--        <sidenav-item-->
<!--          to="/rtl-page"-->
<!--          :class="getRoute() === 'rtl-page' ? 'active' : ''"-->
<!--          navText="RTL"-->
<!--        >-->
<!--          <template v-slot:icon>-->
<!--            <i class="ni ni-world-2 text-danger text-sm opacity-10"></i>-->
<!--          </template>-->
<!--        </sidenav-item>-->
<!--      </li>-->

      <li class="mt-3 nav-item">
        <h6
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 me-4"
        >
          {{$t('base.own')}}
        </h6>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/profile"
          :class="getRoute() === 'profile' ? 'active' : ''"
          :navText="$t('routesMenu.me')"
        >
          <template v-slot:icon>
            <i class="ni ni-single-02 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/message"
          :class="getRoute() === 'message' ? 'active' : ''"
          :navText="$t('routesMenu.message')"
        >
          <template v-slot:icon>
            <i class="ni ni-bell-55 text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

<!--      <li class="nav-item">-->
<!--        <sidenav-item-->
<!--          to="/signup"-->
<!--          :class="getRoute() === 'signup' ? 'active' : ''"-->
<!--          :navText="isRTL ? 'اشتراك' : 'Sign Up'"-->
<!--        >-->
<!--          <template v-slot:icon>-->
<!--            <i class="ni ni-collection text-info text-sm opacity-10"></i>-->
<!--          </template>-->
<!--        </sidenav-item>-->
<!--      </li>-->
    </ul>
  </div>

  <div class="pt-3 mx-3 mt-3 sidenav-footer">
<!--    <sidenav-card/>-->
  </div>
</template>
